<ng-template #textContentHistoryModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">History</h4>
    <button type="button" class="btn btn-close" aria-label="Close" (click)="d()"></button>
  </div>
  <div class="modal-body">
    <rms-text-content-item *ngFor="let item of data; let i = index" [isNote]="true"
       [data]="item" [index]="i" [length]="data.length" [displayMnpi]="true"></rms-text-content-item>
  </div>
</ng-template>
